
<div class="sheet">
    <div class="line">
        <h4 class="upper">{{ 'CART.PAY_NOW' | translate }}</h4>
        <img class="icon-xl" (click)="close()" [src]="'close.svg' | themeSource" alt="close" />
    </div>

    <app-voucher-form (voucherApplied)="onVoucherApplied($event)" [(hideVoucher)]="hideVoucher" [(voucher)]="voucher" />
    <app-tipping-form [total]="firstOrder()?.total_price_without_discount ?? 0" (tipApplied)="onTipApplied($event)" />

    <div class="order-summary">
        <div>
            <span>{{ 'ORDER.SUBTOTAL' | translate }}</span>
            <span>{{ (firstOrder()?.total_price_without_discount ?? 0) | currencySpace }}</span>
        </div>

        @if (appliedVoucher()?.amount && appliedVoucher()?.mode === VoucherMode.Balance) {
            <div>
                <span>{{ 'VOUCHER.CURRENT_BALANCE' | translate }}</span>
                <span>{{ appliedVoucher()?.amount ?? 0 | currencySpace }}</span>
            </div>
        }

        @for (fee of firstOrder()?.fees; track fee.id) {
            @if (fee.amount) {
            <div>
                <span>{{ fee.name }}</span>
                <span>{{ fee.amount | currencySpace }}</span>
            </div>
            }
        }

        @if (appliedPromo(); as promo) {
            @if (promo.amount) {
            <div>
                <span>{{ 'PAY_AT_TABLE.PROMO' | translate }}</span>
                <span>- {{ promo.amount | currencySpace }}</span>
            </div>
            }
        }

        @if (firstOrder()?.discount_amount) {
            <div>
                <span>
                    {{ 'PAY_AT_TABLE.DISCOUNT' | translate }}
                </span>
                <span>
                    - {{ firstOrder()?.discount_amount ?? 0 | currencySpace }}
                </span>
            </div>
        }

        @if (isOrderFree()) {
            <div class="row total">
                <span>{{ 'VOUCHER.REMAINING_BALANCE' | translate }}</span>
                <span>{{ ((appliedVoucher()?.amount ?? 0) - (firstOrder()?.discount_amount ?? 0)) | currencySpace }}</span>
            </div>
        }

        @if (tipAmount()) {
            <div>
                <span>{{ 'TIP.TIP' | translate }}</span>
                <span>{{ tipAmount() | currencySpace }}</span>
            </div>
        }

        <div>
            <span>{{ 'ORDER.TOTAL' | translate }}</span>
            <span>{{ totalWithTip() | currencySpace }}</span>
        </div>
    </div>

    @if (isOrderFree()) {
        <button class="btn" [disabled]="isLoading() && !!firstOrder()" type="button" (click)="checkout()">
            {{ 'ACTIONS.CONFIRM' | translate }}
        </button>
    } @else {
        <app-payment-options-sheet
            [paymentMethods]="paymentTypes"
            [disabled]="isLoading() && !!firstOrder()"
            (optionSelected)="selectPaymentOption($event)">
        </app-payment-options-sheet>
    }

</div>
